<mat-progress-bar
    mode="indeterminate"
    *ngIf="loadingUserFeedback"
></mat-progress-bar>

<form [formGroup]="searchForm">
    <div class="tw-flex tw-flex-col tw-px-8 tw-gap-5">
        <mat-card
            appearance="outlined"
            class="tw-flex tw-flex-col tw-gap-2 tw-col-span-5 lg:tw-r-span-4 2xl:tw-col-span-3 lg:tw-col-start-2 2xl:tw-col-start-2 tw-min-w-fit"
        >
            <mat-card-content class="tw-flex tw-flex-col">
                <div
                    [formGroup]="searchForm"
                    class="tw-flex tw-flex-row tw-w-full tw-gap-5"
                >
                    @if (!userView) {
                        <mat-form-field appearance="fill">
                            <mat-label>User</mat-label>
                            <mat-select
                                formControlName="userSearch"
                                (selectionChange)="setQueryParams()"
                            >
                                <mat-option value="">View All</mat-option>
                                @for (user of users; track user) {
                                    <mat-option [value]="user.id">
                                        {{
                                            user.firstName + " " + user.lastName
                                        }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                    <mat-form-field appearance="fill">
                        <mat-label>Status</mat-label>
                        <mat-select
                            formControlName="statusSearch"
                            (selectionChange)="setQueryParams()"
                        >
                            <mat-option value="">View All</mat-option>
                            <mat-option
                                *ngFor="let status of feedbackStatuses"
                                [value]="status"
                            >
                                {{ status }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card
            appearance="outlined"
            class="tw-flex tw-flex-col tw-gap-2 tw-col-span-5 lg:tw-col-span-4 2xl:tw-col-span-3 lg:tw-col-start-2 2xl:tw-col-start-2 tw-min-w-fit"
        >
            <mat-card-content class="tw-flex tw-flex-col">
                <div
                    class="tw-grid tw-gap-8 tw-max-w-full w-full"
                    style="grid-template-columns: repeat(3, minmax(350px, 33%))"
                >
                    @for (
                        ticket of userFeedbackPaginatedResult.items;
                        track ticket
                    ) {
                        <app-feedback-card
                            [userFeedback]="ticket"
                            [userView]="userView"
                            (showTicketDetails)="
                                displayTicketDetailsMenu($event)
                            "
                        ></app-feedback-card>
                    }
                </div>
            </mat-card-content>
            <mat-card-actions class="tw-flex tw-justify-end">
                <mat-paginator
                    class="tw-bg-transparent"
                    [pageIndex]="pageIndex"
                    [pageSize]="userFeedbackPaginatedResult.countRequested"
                    [length]="userFeedbackPaginatedResult.totalCount"
                    [hidePageSize]="true"
                    (page)="changePage($event)"
                ></mat-paginator>
            </mat-card-actions>
        </mat-card>
    </div>
</form>
